import React from 'react'
import { Router } from './routes/Router'
import { ApolloProvider, useReactiveVar } from '@apollo/client'
import { MuiThemeProvider } from '@material-ui/core/styles'

import createApolloClient from './utils/createApolloClient'

import './styles/App.css'
import baseMuiTheme from './styles/theme'
import Favicon from 'react-favicon'
import { appSubdomainVar } from './graphql/stores/local'
import { SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME } from './constants'
import digikapitaalLogo from './media/digi-kapitaal-nobg.png'
import schoolmakersLogo from './media/logo-schoolmakers.png'
import { subdomain as detectedSubdomain } from './constants'

const apolloClient = createApolloClient()

const App = () => {
  appSubdomainVar(detectedSubdomain)
  const subdomain = useReactiveVar(appSubdomainVar)
  const favicons =
    subdomain === SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME ? [schoolmakersLogo] : [digikapitaalLogo]
  const documentTitle =
    subdomain === SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME ? `Schoolleiderschap` : `Digikapitaal`
  document.title = documentTitle
  // console.log(documentTitle)
  return (
    <>
      <Favicon url={favicons} />
      <ApolloProvider client={apolloClient}>
        <MuiThemeProvider theme={baseMuiTheme(subdomain)}>
          <Router />
        </MuiThemeProvider>
      </ApolloProvider>
    </>
  )
}

export default App
